import { apiService } from './api';
import { PaginationParams } from '../types/common';

export interface RouteDelivery {
  id: string;
  code: string;
  name: string;
  description?: string;
  status: 'ACTIVE' | 'INACTIVE';
  createdAt: string;
  updatedAt: string;
}

export interface RouteDeliveriesResponse {
  routeDeliveries: RouteDelivery[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

class RouteDeliveryService {
  async getRouteDeliveries(params?: PaginationParams & { name?: string; status?: 'ACTIVE' | 'INACTIVE' }): Promise<RouteDeliveriesResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params?.name) queryParams.append('name', params.name);
    if (params?.status) queryParams.append('status', params.status);

    return apiService.get<RouteDeliveriesResponse>(`/route-deliveries?${queryParams.toString()}`);
  }

  async create(data: { name: string; description?: string; status?: 'ACTIVE' | 'INACTIVE'; }): Promise<{ message: string; routeDelivery: RouteDelivery }> {
    return apiService.post('/route-deliveries', data);
  }

  async update(id: string, data: { name?: string; description?: string; status?: 'ACTIVE' | 'INACTIVE'; }): Promise<{ message: string; routeDelivery: RouteDelivery }> {
    return apiService.put(`/route-deliveries/${id}`, data);
  }

  async delete(id: string): Promise<{ message: string }> {
    return apiService.delete(`/route-deliveries/${id}`);
  }

  async bulkUpdateStatus(ids: string[], status: 'ACTIVE' | 'INACTIVE'): Promise<{ success: boolean; message: string; count: number }> {
    return apiService.post<{ success: boolean; message: string; count: number }>(`/route-deliveries/bulk-status`, { ids, status });
  }

  async export(params?: { search?: string; name?: string; status?: 'ACTIVE' | 'INACTIVE'; ids?: string[] }): Promise<Blob> {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.name) queryParams.append('name', params.name);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.ids && params.ids.length) queryParams.append('ids', params.ids.join(','));
    const baseURL = process.env.REACT_APP_API_URL || '/api';
    const response = await fetch(`${baseURL}/route-deliveries/export?${queryParams.toString()}`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
    if (!response.ok) throw new Error('Export failed');
    return response.blob();
  }
}

export const routeDeliveryService = new RouteDeliveryService();

